interface TemplateConfig {
  pages?: {
    pages?: string[];
  };
}

/**
 * Filters page navigation based on VMO version and configuration
 *
 * @param vmoRedesignEnabled - Whether VMO V2 is enabled
 * @param hasDrawPage - Whether draw page should be included
 * @param declarations - Whether to include declarations pages
 * @param templateConfig - Template configuration containing pages
 * @returns Filtered array of page names
 */
export function handleCurrentVmoPage(vmoRedesignEnabled: boolean, hasDrawPage: boolean, declarations: boolean = true, templateConfig?: TemplateConfig): string[] {
  const pages = templateConfig?.pages?.pages || [];

  const isViewMyOfferPage = (page: string): boolean => page.trim().startsWith('View My Offer');

  let filteredPages = [...pages];

  if (vmoRedesignEnabled) {
    let hasFoundFirstVMO = false;
    filteredPages = filteredPages.filter((page) => {
      if (isViewMyOfferPage(page)) {
        if (!hasFoundFirstVMO) {
          hasFoundFirstVMO = true;
          return true;
        }
        return false;
      }
      return true;
    });
  } else if (!hasDrawPage) {
    const vmoIndex = filteredPages.findIndex(isViewMyOfferPage);
    if (vmoIndex !== -1) {
      filteredPages.splice(vmoIndex, 1);
    }
  }

  if (!declarations) {
    filteredPages = filteredPages.filter((page) => page.toLowerCase() !== 'declarations');
  }

  return filteredPages;
}
